(function (e) {
  "use strict";
  e(jQuery);
})(function (e, t) {
  "use strict";
  function f(t, n, r, i) {
    var o = [];
    for (var u = 0; u < t.length; u++) {
      var a = t[u];
      if (a) {
        var f = tinycolor(a);
        var l =
          f.toHsl().l < 0.5
            ? "sp-thumb-el sp-thumb-dark"
            : "sp-thumb-el sp-thumb-light";
        l += tinycolor.equals(n, a) ? " sp-thumb-active" : "";
        var c = f.toString(i.preferredFormat || "rgb");
        var h = s
          ? "background-color:" + f.toRgbString()
          : "filter:" + f.toFilter();
        o.push(
          '<span title="' +
            c +
            '" data-color="' +
            f.toRgbString() +
            '" class="' +
            l +
            '"><span class="sp-thumb-inner" style="' +
            h +
            ';" /></span>',
        );
      } else {
        var p = "sp-clear-display";
        o.push(
          e("<div />")
            .append(
              e(
                '<span data-color="" style="background-color:transparent;" class="' +
                  p +
                  '"></span>',
              ).attr("title", i.noColorSelectedText),
            )
            .html(),
        );
      }
    }
    return "<div class='sp-cf " + r + "'>" + o.join("") + "</div>";
  }
  function l() {
    for (var e = 0; e < r.length; e++) {
      if (r[e]) {
        r[e].hide();
      }
    }
  }
  function c(t, r) {
    var i = e.extend({}, n, t);
    i.callbacks = {
      move: m(i.move, r),
      change: m(i.change, r),
      show: m(i.show, r),
      hide: m(i.hide, r),
      beforeShow: m(i.beforeShow, r),
    };
    return i;
  }
  function h(n, h) {
    function Tt() {
      if (d.showPaletteOnly) {
        d.showPalette = true;
      }
      lt.text(
        d.showPaletteOnly ? d.togglePaletteMoreText : d.togglePaletteLessText,
      );
      if (d.palette) {
        j = d.palette.slice(0);
        F = e.isArray(j[0]) ? j : [j];
        I = {};
        for (var t = 0; t < F.length; t++) {
          for (var n = 0; n < F[t].length; n++) {
            var r = tinycolor(F[t][n]).toRgbString();
            I[r] = true;
          }
        }
      }
      K.toggleClass("sp-flat", m);
      K.toggleClass("sp-input-disabled", !d.showInput);
      K.toggleClass("sp-alpha-enabled", d.showAlpha);
      K.toggleClass("sp-clear-enabled", xt);
      K.toggleClass("sp-buttons-disabled", !d.showButtons);
      K.toggleClass("sp-palette-buttons-disabled", !d.togglePaletteOnly);
      K.toggleClass("sp-palette-disabled", !d.showPalette);
      K.toggleClass("sp-palette-only", d.showPaletteOnly);
      K.toggleClass("sp-initial-disabled", !d.showInitial);
      K.addClass(d.className).addClass(d.containerClassName);
      Vt();
    }
    function Nt() {
      function n(t) {
        if (t.data && t.data.ignore) {
          It(e(t.target).closest(".sp-thumb-el").data("color"));
          Ut();
        } else {
          It(e(t.target).closest(".sp-thumb-el").data("color"));
          Ut();
          Xt(true);
          if (d.hideAfterPaletteSelect) {
            jt();
          }
        }
        return false;
      }
      if (i) {
        K.find("*:not(input)").attr("unselectable", "on");
      }
      Tt();
      if (pt) {
        V.after(dt).hide();
      }
      if (!xt) {
        at.hide();
      }
      if (m) {
        V.after(K).hide();
      } else {
        var t = d.appendTo === "parent" ? V.parent() : e(d.appendTo);
        if (t.length !== 1) {
          t = e("body");
        }
        t.append(K);
      }
      Ct();
      vt.bind("click.spectrum touchstart.spectrum", function (t) {
        if (!J) {
          Pt();
        }
        t.stopPropagation();
        if (!e(t.target).is("input")) {
          t.preventDefault();
        }
      });
      if (V.is(":disabled") || d.disabled === true) {
        Qt();
      }
      K.click(v);
      it.change(Dt);
      it.bind("paste", function () {
        setTimeout(Dt, 1);
      });
      it.keydown(function (e) {
        if (e.keyCode == 13) {
          Dt();
        }
      });
      ut.text(d.cancelText);
      ut.bind("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        Ft();
        jt();
      });
      at.attr("title", d.clearText);
      at.bind("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        St = true;
        Ut();
        if (m) {
          Xt(true);
        }
      });
      ft.text(d.chooseText);
      ft.bind("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (i && it.is(":focus")) {
          it.trigger("change");
        }
        if (Rt()) {
          Xt(true);
          jt();
        }
      });
      lt.text(
        d.showPaletteOnly ? d.togglePaletteMoreText : d.togglePaletteLessText,
      );
      lt.bind("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        d.showPaletteOnly = !d.showPaletteOnly;
        if (!d.showPaletteOnly && !m) {
          K.css("left", "-=" + (Q.outerWidth(true) + 5));
        }
        Tt();
      });
      g(
        nt,
        function (e, t, n) {
          B = e / O;
          St = false;
          if (n.shiftKey) {
            B = Math.round(B * 10) / 10;
          }
          Ut();
        },
        Mt,
        _t,
      );
      g(
        Z,
        function (e, t) {
          D = parseFloat(t / L);
          St = false;
          if (!d.showAlpha) {
            B = 1;
          }
          Ut();
        },
        Mt,
        _t,
      );
      g(
        G,
        function (e, t, n) {
          if (!n.shiftKey) {
            z = null;
          } else if (!z) {
            var r = P * N;
            var i = C - H * C;
            var s = Math.abs(e - r) > Math.abs(t - i);
            z = s ? "x" : "y";
          }
          var o = !z || z === "x";
          var u = !z || z === "y";
          if (o) {
            P = parseFloat(e / N);
          }
          if (u) {
            H = parseFloat((C - t) / C);
          }
          St = false;
          if (!d.showAlpha) {
            B = 1;
          }
          Ut();
        },
        Mt,
        _t,
      );
      if (!!gt) {
        It(gt);
        zt();
        wt = bt || tinycolor(gt).format;
        kt(gt);
      } else {
        zt();
      }
      if (m) {
        Ht();
      }
      var r = i ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
      st.delegate(".sp-thumb-el", r, n);
      ot.delegate(".sp-thumb-el:nth-child(1)", r, { ignore: true }, n);
    }
    function Ct() {
      if (w && window.localStorage) {
        try {
          var t = window.localStorage[w].split(",#");
          if (t.length > 1) {
            delete window.localStorage[w];
            e.each(t, function (e, t) {
              kt(t);
            });
          }
        } catch (n) {}
        try {
          q = window.localStorage[w].split(";");
        } catch (n) {}
      }
    }
    function kt(t) {
      if (b) {
        var n = tinycolor(t).toRgbString();
        if (!I[n] && e.inArray(n, q) === -1) {
          q.push(n);
          while (q.length > R) {
            q.shift();
          }
        }
        if (w && window.localStorage) {
          try {
            window.localStorage[w] = q.join(";");
          } catch (r) {}
        }
      }
    }
    function Lt() {
      var e = [];
      if (d.showPalette) {
        for (var t = 0; t < q.length; t++) {
          var n = tinycolor(q[t]).toRgbString();
          if (!I[n]) {
            e.push(q[t]);
          }
        }
      }
      return e.reverse().slice(0, d.maxSelectionSize);
    }
    function At() {
      var t = qt();
      var n = e.map(F, function (e, n) {
        return f(e, t, "sp-palette-row sp-palette-row-" + n, d);
      });
      Ct();
      if (q) {
        n.push(f(Lt(), t, "sp-palette-row sp-palette-row-selection", d));
      }
      st.html(n.join(""));
    }
    function Ot() {
      if (d.showInitial) {
        var e = yt;
        var t = qt();
        ot.html(f([e, t], t, "sp-palette-row-initial", d));
      }
    }
    function Mt() {
      if (C <= 0 || N <= 0 || L <= 0) {
        Vt();
      }
      K.addClass(U);
      z = null;
      V.trigger("dragstart.spectrum", [qt()]);
    }
    function _t() {
      K.removeClass(U);
      V.trigger("dragstop.spectrum", [qt()]);
    }
    function Dt() {
      var e = it.val();
      if ((e === null || e === "") && xt) {
        It(null);
        Xt(true);
      } else {
        var t = tinycolor(e);
        if (t.isValid()) {
          It(t);
          Xt(true);
        } else {
          it.addClass("sp-validation-error");
        }
      }
    }
    function Pt() {
      if (T) {
        jt();
      } else {
        Ht();
      }
    }
    function Ht() {
      var t = e.Event("beforeShow.spectrum");
      if (T) {
        Vt();
        return;
      }
      V.trigger(t, [qt()]);
      if (S.beforeShow(qt()) === false || t.isDefaultPrevented()) {
        return;
      }
      l();
      T = true;
      e(W).bind("click.spectrum", Bt);
      e(window).bind("resize.spectrum", x);
      dt.addClass("sp-active");
      K.removeClass("sp-hidden");
      Vt();
      zt();
      yt = qt();
      Ot();
      S.show(yt);
      V.trigger("show.spectrum", [yt]);
    }
    function Bt(e) {
      if (e.button == 2) {
        return;
      }
      if (Et) {
        Xt(true);
      } else {
        Ft();
      }
      jt();
    }
    function jt() {
      if (!T || m) {
        return;
      }
      T = false;
      e(W).unbind("click.spectrum", Bt);
      e(window).unbind("resize.spectrum", x);
      dt.removeClass("sp-active");
      K.addClass("sp-hidden");
      S.hide(qt());
      V.trigger("hide.spectrum", [qt()]);
    }
    function Ft() {
      It(yt, true);
    }
    function It(e, t) {
      if (tinycolor.equals(e, qt())) {
        zt();
        return;
      }
      var n, r;
      if (!e && xt) {
        St = true;
      } else {
        St = false;
        n = tinycolor(e);
        r = n.toHsv();
        D = (r.h % 360) / 360;
        P = r.s;
        H = r.v;
        B = r.a;
      }
      zt();
      if (n && n.isValid() && !t) {
        wt = bt || n.getFormat();
      }
    }
    function qt(e) {
      e = e || {};
      if (xt && St) {
        return null;
      }
      return tinycolor.fromRatio(
        { h: D, s: P, v: H, a: Math.round(B * 100) / 100 },
        { format: e.format || wt },
      );
    }
    function Rt() {
      return !it.hasClass("sp-validation-error");
    }
    function Ut() {
      zt();
      S.move(qt());
      V.trigger("move.spectrum", [qt()]);
    }
    function zt() {
      it.removeClass("sp-validation-error");
      Wt();
      var e = tinycolor.fromRatio({ h: D, s: 1, v: 1 });
      G.css("background-color", e.toHexString());
      var t = wt;
      if (B < 1 && !(B === 0 && t === "name")) {
        if (t === "hex" || t === "hex3" || t === "hex6" || t === "name") {
          t = "rgb";
        }
      }
      var n = qt({ format: t }),
        r = "";
      mt.removeClass("sp-clear-display");
      mt.css("background-color", "transparent");
      if (!n && xt) {
        mt.addClass("sp-clear-display");
      } else {
        var o = n.toHexString(),
          u = n.toRgbString();
        if (s || n.alpha === 1) {
          mt.css("background-color", u);
        } else {
          mt.css("background-color", "transparent");
          mt.css("filter", n.toFilter());
        }
        if (d.showAlpha) {
          var a = n.toRgb();
          a.a = 0;
          var f = tinycolor(a).toRgbString();
          var l = "linear-gradient(left, " + f + ", " + o + ")";
          if (i) {
            tt.css("filter", tinycolor(f).toFilter({ gradientType: 1 }, o));
          } else {
            tt.css("background", "-webkit-" + l);
            tt.css("background", "-moz-" + l);
            tt.css("background", "-ms-" + l);
            tt.css(
              "background",
              "linear-gradient(to right, " + f + ", " + o + ")",
            );
          }
        }
        r = n.toString(t);
      }
      if (d.showInput) {
        it.val(r);
      }
      if (d.showPalette) {
        At();
      }
      Ot();
    }
    function Wt() {
      var e = P;
      var t = H;
      if (xt && St) {
        rt.hide();
        et.hide();
        Y.hide();
      } else {
        rt.show();
        et.show();
        Y.show();
        var n = e * N;
        var r = C - t * C;
        n = Math.max(-k, Math.min(N - k, n - k));
        r = Math.max(-k, Math.min(C - k, r - k));
        Y.css({ top: r + "px", left: n + "px" });
        var i = B * O;
        rt.css({ left: i - M / 2 + "px" });
        var s = D * L;
        et.css({ top: s - _ + "px" });
      }
    }
    function Xt(e) {
      var t = qt(),
        n = "",
        r = !tinycolor.equals(t, yt);
      if (t) {
        n = t.toString(wt);
        kt(t);
      }
      if (ct) {
        V.val(n);
      }
      if (e && r) {
        S.change(t);
        V.trigger("change", [t]);
      }
    }
    function Vt() {
      N = G.width();
      C = G.height();
      k = Y.height();
      A = Z.width();
      L = Z.height();
      _ = et.height();
      O = nt.width();
      M = rt.width();
      if (!m) {
        K.css("position", "absolute");
        if (d.offset) {
          K.offset(d.offset);
        } else {
          K.offset(p(K, vt));
        }
      }
      Wt();
      if (d.showPalette) {
        At();
      }
      V.trigger("reflow.spectrum");
    }
    function $t() {
      V.show();
      vt.unbind("click.spectrum touchstart.spectrum");
      K.remove();
      dt.remove();
      r[Yt.id] = null;
    }
    function Jt(n, r) {
      if (n === t) {
        return e.extend({}, d);
      }
      if (r === t) {
        return d[n];
      }
      d[n] = r;
      Tt();
    }
    function Kt() {
      J = false;
      V.attr("disabled", false);
      vt.removeClass("sp-disabled");
    }
    function Qt() {
      jt();
      J = true;
      V.attr("disabled", true);
      vt.addClass("sp-disabled");
    }
    function Gt(e) {
      d.offset = e;
      Vt();
    }
    var d = c(h, n),
      m = d.flat,
      b = d.showSelectionPalette,
      w = d.localStorageKey,
      E = d.theme,
      S = d.callbacks,
      x = y(Vt, 10),
      T = false,
      N = 0,
      C = 0,
      k = 0,
      L = 0,
      A = 0,
      O = 0,
      M = 0,
      _ = 0,
      D = 0,
      P = 0,
      H = 0,
      B = 1,
      j = [],
      F = [],
      I = {},
      q = d.selectionPalette.slice(0),
      R = d.maxSelectionSize,
      U = "sp-dragging",
      z = null;
    var W = n.ownerDocument,
      X = W.body,
      V = e(n),
      J = false,
      K = e(a, W).addClass(E),
      Q = K.find(".sp-picker-container"),
      G = K.find(".sp-color"),
      Y = K.find(".sp-dragger"),
      Z = K.find(".sp-hue"),
      et = K.find(".sp-slider"),
      tt = K.find(".sp-alpha-inner"),
      nt = K.find(".sp-alpha"),
      rt = K.find(".sp-alpha-handle"),
      it = K.find(".sp-input"),
      st = K.find(".sp-palette"),
      ot = K.find(".sp-initial"),
      ut = K.find(".sp-cancel"),
      at = K.find(".sp-clear"),
      ft = K.find(".sp-choose"),
      lt = K.find(".sp-palette-toggle"),
      ct = V.is("input"),
      ht = ct && o && V.attr("type") === "color",
      pt = ct && !m,
      dt = pt
        ? e(u).addClass(E).addClass(d.className).addClass(d.replacerClassName)
        : e([]),
      vt = pt ? dt : V,
      mt = dt.find(".sp-preview-inner"),
      gt = d.color || (ct && V.val()),
      yt = false,
      bt = d.preferredFormat,
      wt = bt,
      Et = !d.showButtons || d.clickoutFiresChange,
      St = !gt,
      xt = d.allowEmpty && !ht;
    Nt();
    var Yt = {
      show: Ht,
      hide: jt,
      toggle: Pt,
      reflow: Vt,
      option: Jt,
      enable: Kt,
      disable: Qt,
      offset: Gt,
      set: function (e) {
        It(e);
        Xt();
      },
      get: qt,
      destroy: $t,
      container: K,
    };
    Yt.id = r.push(Yt) - 1;
    return Yt;
  }
  function p(t, n) {
    var r = 0;
    var i = t.outerWidth();
    var s = t.outerHeight();
    var o = n.outerHeight();
    var u = t[0].ownerDocument;
    var a = u.documentElement;
    var f = a.clientWidth + e(u).scrollLeft();
    var l = a.clientHeight + e(u).scrollTop();
    var c = n.offset();
    c.top += o;
    c.left -= Math.min(
      c.left,
      c.left + i > f && f > i ? Math.abs(c.left + i - f) : 0,
    );
    c.top -= Math.min(c.top, c.top + s > l && l > s ? Math.abs(s + o - r) : r);
    return c;
  }
  function d() {}
  function v(e) {
    e.stopPropagation();
  }
  function m(e, t) {
    var n = Array.prototype.slice;
    var r = n.call(arguments, 2);
    return function () {
      return e.apply(t, r.concat(n.call(arguments)));
    };
  }
  function g(t, n, r, s) {
    function p(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.returnValue = false;
    }
    function d(e) {
      if (u) {
        if (i && o.documentMode < 9 && !e.button) {
          return m();
        }
        var r = e.originalEvent && e.originalEvent.touches;
        var s = r ? r[0].pageX : e.pageX;
        var h = r ? r[0].pageY : e.pageY;
        var d = Math.max(0, Math.min(s - a.left, l));
        var v = Math.max(0, Math.min(h - a.top, f));
        if (c) {
          p(e);
        }
        n.apply(t, [d, v, e]);
      }
    }
    function v(n) {
      var i = n.which ? n.which == 3 : n.button == 2;
      if (!i && !u) {
        if (r.apply(t, arguments) !== false) {
          u = true;
          f = e(t).height();
          l = e(t).width();
          a = e(t).offset();
          e(o).bind(h);
          e(o.body).addClass("sp-dragging");
          if (!c) {
            d(n);
          }
          p(n);
        }
      }
    }
    function m() {
      if (u) {
        e(o).unbind(h);
        e(o.body).removeClass("sp-dragging");
        s.apply(t, arguments);
      }
      u = false;
    }
    n = n || function () {};
    r = r || function () {};
    s = s || function () {};
    var o = document;
    var u = false;
    var a = {};
    var f = 0;
    var l = 0;
    var c = "ontouchstart" in window;
    var h = {};
    h["selectstart"] = p;
    h["dragstart"] = p;
    h["touchmove mousemove"] = d;
    h["touchend mouseup"] = m;
    e(t).bind("touchstart mousedown", v);
  }
  function y(e, t, n) {
    var r;
    return function () {
      var i = this,
        s = arguments;
      var o = function () {
        r = null;
        e.apply(i, s);
      };
      if (n) clearTimeout(r);
      if (n || !r) r = setTimeout(o, t);
    };
  }
  var n = {
      beforeShow: d,
      move: d,
      change: d,
      show: d,
      hide: d,
      color: false,
      flat: false,
      showInput: false,
      allowEmpty: false,
      showButtons: true,
      clickoutFiresChange: false,
      showInitial: false,
      showPalette: false,
      showPaletteOnly: false,
      hideAfterPaletteSelect: false,
      togglePaletteOnly: false,
      showSelectionPalette: true,
      localStorageKey: false,
      appendTo: "body",
      maxSelectionSize: 7,
      cancelText: "cancel",
      chooseText: "choose",
      togglePaletteMoreText: "more",
      togglePaletteLessText: "less",
      clearText: "Clear Color Selection",
      noColorSelectedText: "No Color Selected",
      preferredFormat: false,
      className: "",
      containerClassName: "",
      replacerClassName: "",
      showAlpha: false,
      theme: "sp-light",
      palette: [
        [
          "#ffffff",
          "#000000",
          "#ff0000",
          "#ff8000",
          "#ffff00",
          "#008000",
          "#0000ff",
          "#4b0082",
          "#9400d3",
        ],
      ],
      selectionPalette: [],
      disabled: false,
      offset: null,
    },
    r = [],
    i = !!/msie/i.exec(window.navigator.userAgent),
    s = (function () {
      function e(e, t) {
        return !!~("" + e).indexOf(t);
      }
      var t = document.createElement("div");
      var n = t.style;
      n.cssText = "background-color:rgba(0,0,0,.5)";
      return e(n.backgroundColor, "rgba") || e(n.backgroundColor, "hsla");
    })(),
    o = (function () {
      var t = e("<input type='color' value='!' />")[0];
      return t.type === "color" && t.value !== "!";
    })(),
    u = [
      "<div class='sp-replacer'>",
      "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
      "<div class='sp-dd'>&#9660;</div>",
      "</div>",
    ].join(""),
    a = (function () {
      var e = "";
      if (i) {
        for (var t = 1; t <= 6; t++) {
          e += "<div class='sp-" + t + "'></div>";
        }
      }
      return [
        "<div class='sp-container sp-hidden'>",
        "<div class='sp-palette-container'>",
        "<div class='sp-palette sp-thumb sp-cf'></div>",
        "<div class='sp-palette-button-container sp-cf'>",
        "<button type='button' class='sp-palette-toggle'></button>",
        "</div>",
        "</div>",
        "<div class='sp-picker-container'>",
        "<div class='sp-top sp-cf'>",
        "<div class='sp-fill'></div>",
        "<div class='sp-top-inner'>",
        "<div class='sp-color'>",
        "<div class='sp-sat'>",
        "<div class='sp-val'>",
        "<div class='sp-dragger'></div>",
        "</div>",
        "</div>",
        "</div>",
        "<div class='sp-clear sp-clear-display'>",
        "</div>",
        "<div class='sp-hue'>",
        "<div class='sp-slider'></div>",
        e,
        "</div>",
        "</div>",
        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
        "</div>",
        "<div class='sp-input-container sp-cf'>",
        "<input class='sp-input' type='text' spellcheck='false'  />",
        "</div>",
        "<div class='sp-initial sp-thumb sp-cf'></div>",
        "<div class='sp-button-container sp-cf'>",
        "<a class='sp-cancel' href='#'></a>",
        "<button type='button' class='sp-choose'></button>",
        "</div>",
        "</div>",
        "</div>",
      ].join("");
    })();
  var b = "spectrum.id";
  e.fn.spectrum = function (t, n) {
    if (typeof t == "string") {
      var i = this;
      var s = Array.prototype.slice.call(arguments, 1);
      this.each(function () {
        var n = r[e(this).data(b)];
        if (n) {
          var o = n[t];
          if (!o) {
            throw new Error("Spectrum: no such method: '" + t + "'");
          }
          if (t == "get") {
            i = n.get();
          } else if (t == "container") {
            i = n.container;
          } else if (t == "option") {
            i = n.option.apply(n, s);
          } else if (t == "destroy") {
            n.destroy();
            e(this).removeData(b);
          } else {
            o.apply(n, s);
          }
        }
      });
      return i;
    }
    return this.spectrum("destroy").each(function () {
      var n = e.extend({}, t, e(this).data());
      var r = h(this, n);
      e(this).data(b, r.id);
    });
  };
  e.fn.spectrum.load = true;
  e.fn.spectrum.loadOpts = {};
  e.fn.spectrum.draggable = g;
  e.fn.spectrum.defaults = n;
  e.spectrum = {};
  e.spectrum.localization = {};
  e.spectrum.palettes = {};
  e.fn.spectrum.processNativeColorInputs = function () {
    if (!o) {
      e("input[type=color]").spectrum({ preferredFormat: "hex6" });
    }
  };
  (function () {
    function f(e) {
      var t = { r: 0, g: 0, b: 0 };
      var n = 1;
      var r = false;
      var i = false;
      if (typeof e == "string") {
        e = W(e);
      }
      if (typeof e == "object") {
        if (
          e.hasOwnProperty("r") &&
          e.hasOwnProperty("g") &&
          e.hasOwnProperty("b")
        ) {
          t = l(e.r, e.g, e.b);
          r = true;
          i = String(e.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if (
          e.hasOwnProperty("h") &&
          e.hasOwnProperty("s") &&
          e.hasOwnProperty("v")
        ) {
          e.s = q(e.s);
          e.v = q(e.v);
          t = d(e.h, e.s, e.v);
          r = true;
          i = "hsv";
        } else if (
          e.hasOwnProperty("h") &&
          e.hasOwnProperty("s") &&
          e.hasOwnProperty("l")
        ) {
          e.s = q(e.s);
          e.l = q(e.l);
          t = h(e.h, e.s, e.l);
          r = true;
          i = "hsl";
        }
        if (e.hasOwnProperty("a")) {
          n = e.a;
        }
      }
      n = D(n);
      return {
        ok: r,
        format: e.format || i,
        r: s(255, o(t.r, 0)),
        g: s(255, o(t.g, 0)),
        b: s(255, o(t.b, 0)),
        a: n,
      };
    }
    function l(e, t, n) {
      return { r: P(e, 255) * 255, g: P(t, 255) * 255, b: P(n, 255) * 255 };
    }
    function c(e, t, n) {
      e = P(e, 255);
      t = P(t, 255);
      n = P(n, 255);
      var r = o(e, t, n),
        i = s(e, t, n);
      var u,
        a,
        f = (r + i) / 2;
      if (r == i) {
        u = a = 0;
      } else {
        var l = r - i;
        a = f > 0.5 ? l / (2 - r - i) : l / (r + i);
        switch (r) {
          case e:
            u = (t - n) / l + (t < n ? 6 : 0);
            break;
          case t:
            u = (n - e) / l + 2;
            break;
          case n:
            u = (e - t) / l + 4;
            break;
        }
        u /= 6;
      }
      return { h: u, s: a, l: f };
    }
    function h(e, t, n) {
      function o(e, t, n) {
        if (n < 0) n += 1;
        if (n > 1) n -= 1;
        if (n < 1 / 6) return e + (t - e) * 6 * n;
        if (n < 1 / 2) return t;
        if (n < 2 / 3) return e + (t - e) * (2 / 3 - n) * 6;
        return e;
      }
      var r, i, s;
      e = P(e, 360);
      t = P(t, 100);
      n = P(n, 100);
      if (t === 0) {
        r = i = s = n;
      } else {
        var u = n < 0.5 ? n * (1 + t) : n + t - n * t;
        var a = 2 * n - u;
        r = o(a, u, e + 1 / 3);
        i = o(a, u, e);
        s = o(a, u, e - 1 / 3);
      }
      return { r: r * 255, g: i * 255, b: s * 255 };
    }
    function p(e, t, n) {
      e = P(e, 255);
      t = P(t, 255);
      n = P(n, 255);
      var r = o(e, t, n),
        i = s(e, t, n);
      var u,
        a,
        f = r;
      var l = r - i;
      a = r === 0 ? 0 : l / r;
      if (r == i) {
        u = 0;
      } else {
        switch (r) {
          case e:
            u = (t - n) / l + (t < n ? 6 : 0);
            break;
          case t:
            u = (n - e) / l + 2;
            break;
          case n:
            u = (e - t) / l + 4;
            break;
        }
        u /= 6;
      }
      return { h: u, s: a, v: f };
    }
    function d(e, t, n) {
      e = P(e, 360) * 6;
      t = P(t, 100);
      n = P(n, 100);
      var i = r.floor(e),
        s = e - i,
        o = n * (1 - t),
        u = n * (1 - s * t),
        a = n * (1 - (1 - s) * t),
        f = i % 6,
        l = [n, u, o, o, a, n][f],
        c = [a, n, n, u, o, o][f],
        h = [o, o, a, n, n, u][f];
      return { r: l * 255, g: c * 255, b: h * 255 };
    }
    function v(e, t, n, r) {
      var s = [
        I(i(e).toString(16)),
        I(i(t).toString(16)),
        I(i(n).toString(16)),
      ];
      if (
        r &&
        s[0].charAt(0) == s[0].charAt(1) &&
        s[1].charAt(0) == s[1].charAt(1) &&
        s[2].charAt(0) == s[2].charAt(1)
      ) {
        return s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0);
      }
      return s.join("");
    }
    function m(e, t, n, r) {
      var s = [
        I(R(r)),
        I(i(e).toString(16)),
        I(i(t).toString(16)),
        I(i(n).toString(16)),
      ];
      return s.join("");
    }
    function g(e, t) {
      t = t === 0 ? 0 : t || 10;
      var n = a(e).toHsl();
      n.s -= t / 100;
      n.s = H(n.s);
      return a(n);
    }
    function y(e, t) {
      t = t === 0 ? 0 : t || 10;
      var n = a(e).toHsl();
      n.s += t / 100;
      n.s = H(n.s);
      return a(n);
    }
    function b(e) {
      return a(e).desaturate(100);
    }
    function w(e, t) {
      t = t === 0 ? 0 : t || 10;
      var n = a(e).toHsl();
      n.l += t / 100;
      n.l = H(n.l);
      return a(n);
    }
    function E(e, t) {
      t = t === 0 ? 0 : t || 10;
      var n = a(e).toRgb();
      n.r = o(0, s(255, n.r - i(255 * -(t / 100))));
      n.g = o(0, s(255, n.g - i(255 * -(t / 100))));
      n.b = o(0, s(255, n.b - i(255 * -(t / 100))));
      return a(n);
    }
    function S(e, t) {
      t = t === 0 ? 0 : t || 10;
      var n = a(e).toHsl();
      n.l -= t / 100;
      n.l = H(n.l);
      return a(n);
    }
    function x(e, t) {
      var n = a(e).toHsl();
      var r = (i(n.h) + t) % 360;
      n.h = r < 0 ? 360 + r : r;
      return a(n);
    }
    function T(e) {
      var t = a(e).toHsl();
      t.h = (t.h + 180) % 360;
      return a(t);
    }
    function N(e) {
      var t = a(e).toHsl();
      var n = t.h;
      return [
        a(e),
        a({ h: (n + 120) % 360, s: t.s, l: t.l }),
        a({ h: (n + 240) % 360, s: t.s, l: t.l }),
      ];
    }
    function C(e) {
      var t = a(e).toHsl();
      var n = t.h;
      return [
        a(e),
        a({ h: (n + 90) % 360, s: t.s, l: t.l }),
        a({ h: (n + 180) % 360, s: t.s, l: t.l }),
        a({ h: (n + 270) % 360, s: t.s, l: t.l }),
      ];
    }
    function k(e) {
      var t = a(e).toHsl();
      var n = t.h;
      return [
        a(e),
        a({ h: (n + 72) % 360, s: t.s, l: t.l }),
        a({ h: (n + 216) % 360, s: t.s, l: t.l }),
      ];
    }
    function L(e, t, n) {
      t = t || 6;
      n = n || 30;
      var r = a(e).toHsl();
      var i = 360 / n;
      var s = [a(e)];
      for (r.h = (r.h - ((i * t) >> 1) + 720) % 360; --t; ) {
        r.h = (r.h + i) % 360;
        s.push(a(r));
      }
      return s;
    }
    function A(e, t) {
      t = t || 6;
      var n = a(e).toHsv();
      var r = n.h,
        i = n.s,
        s = n.v;
      var o = [];
      var u = 1 / t;
      while (t--) {
        o.push(a({ h: r, s: i, v: s }));
        s = (s + u) % 1;
      }
      return o;
    }
    function _(e) {
      var t = {};
      for (var n in e) {
        if (e.hasOwnProperty(n)) {
          t[e[n]] = n;
        }
      }
      return t;
    }
    function D(e) {
      e = parseFloat(e);
      if (isNaN(e) || e < 0 || e > 1) {
        e = 1;
      }
      return e;
    }
    function P(e, t) {
      if (j(e)) {
        e = "100%";
      }
      var n = F(e);
      e = s(t, o(0, parseFloat(e)));
      if (n) {
        e = parseInt(e * t, 10) / 100;
      }
      if (r.abs(e - t) < 1e-6) {
        return 1;
      }
      return (e % t) / parseFloat(t);
    }
    function H(e) {
      return s(1, o(0, e));
    }
    function B(e) {
      return parseInt(e, 16);
    }
    function j(e) {
      return (
        typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1
      );
    }
    function F(e) {
      return typeof e === "string" && e.indexOf("%") != -1;
    }
    function I(e) {
      return e.length == 1 ? "0" + e : "" + e;
    }
    function q(e) {
      if (e <= 1) {
        e = e * 100 + "%";
      }
      return e;
    }
    function R(e) {
      return Math.round(parseFloat(e) * 255).toString(16);
    }
    function U(e) {
      return B(e) / 255;
    }
    function W(n) {
      n = n.replace(e, "").replace(t, "").toLowerCase();
      var r = false;
      if (O[n]) {
        n = O[n];
        r = true;
      } else if (n == "transparent") {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      }
      var i;
      if ((i = z.rgb.exec(n))) {
        return { r: i[1], g: i[2], b: i[3] };
      }
      if ((i = z.rgba.exec(n))) {
        return { r: i[1], g: i[2], b: i[3], a: i[4] };
      }
      if ((i = z.hsl.exec(n))) {
        return { h: i[1], s: i[2], l: i[3] };
      }
      if ((i = z.hsla.exec(n))) {
        return { h: i[1], s: i[2], l: i[3], a: i[4] };
      }
      if ((i = z.hsv.exec(n))) {
        return { h: i[1], s: i[2], v: i[3] };
      }
      if ((i = z.hsva.exec(n))) {
        return { h: i[1], s: i[2], v: i[3], a: i[4] };
      }
      if ((i = z.hex8.exec(n))) {
        return {
          a: U(i[1]),
          r: B(i[2]),
          g: B(i[3]),
          b: B(i[4]),
          format: r ? "name" : "hex8",
        };
      }
      if ((i = z.hex6.exec(n))) {
        return {
          r: B(i[1]),
          g: B(i[2]),
          b: B(i[3]),
          format: r ? "name" : "hex",
        };
      }
      if ((i = z.hex3.exec(n))) {
        return {
          r: B(i[1] + "" + i[1]),
          g: B(i[2] + "" + i[2]),
          b: B(i[3] + "" + i[3]),
          format: r ? "name" : "hex",
        };
      }
      return false;
    }
    var e = /^[\s,#]+/,
      t = /\s+$/,
      n = 0,
      r = Math,
      i = r.round,
      s = r.min,
      o = r.max,
      u = r.random;
    var a = function (e, t) {
      e = e ? e : "";
      t = t || {};
      if (e instanceof a) {
        return e;
      }
      if (!(this instanceof a)) {
        return new a(e, t);
      }
      var r = f(e);
      ((this._originalInput = e),
        (this._r = r.r),
        (this._g = r.g),
        (this._b = r.b),
        (this._a = r.a),
        (this._roundA = i(100 * this._a) / 100),
        (this._format = t.format || r.format));
      this._gradientType = t.gradientType;
      if (this._r < 1) {
        this._r = i(this._r);
      }
      if (this._g < 1) {
        this._g = i(this._g);
      }
      if (this._b < 1) {
        this._b = i(this._b);
      }
      this._ok = r.ok;
      this._tc_id = n++;
    };
    a.prototype = {
      isDark: function () {
        return this.getBrightness() < 128;
      },
      isLight: function () {
        return !this.isDark();
      },
      isValid: function () {
        return this._ok;
      },
      getOriginalInput: function () {
        return this._originalInput;
      },
      getFormat: function () {
        return this._format;
      },
      getAlpha: function () {
        return this._a;
      },
      getBrightness: function () {
        var e = this.toRgb();
        return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
      },
      setAlpha: function (e) {
        this._a = D(e);
        this._roundA = i(100 * this._a) / 100;
        return this;
      },
      toHsv: function () {
        var e = p(this._r, this._g, this._b);
        return { h: e.h * 360, s: e.s, v: e.v, a: this._a };
      },
      toHsvString: function () {
        var e = p(this._r, this._g, this._b);
        var t = i(e.h * 360),
          n = i(e.s * 100),
          r = i(e.v * 100);
        return this._a == 1
          ? "hsv(" + t + ", " + n + "%, " + r + "%)"
          : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
      },
      toHsl: function () {
        var e = c(this._r, this._g, this._b);
        return { h: e.h * 360, s: e.s, l: e.l, a: this._a };
      },
      toHslString: function () {
        var e = c(this._r, this._g, this._b);
        var t = i(e.h * 360),
          n = i(e.s * 100),
          r = i(e.l * 100);
        return this._a == 1
          ? "hsl(" + t + ", " + n + "%, " + r + "%)"
          : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
      },
      toHex: function (e) {
        return v(this._r, this._g, this._b, e);
      },
      toHexString: function (e) {
        return "#" + this.toHex(e);
      },
      toHex8: function () {
        return m(this._r, this._g, this._b, this._a);
      },
      toHex8String: function () {
        return "#" + this.toHex8();
      },
      toRgb: function () {
        return { r: i(this._r), g: i(this._g), b: i(this._b), a: this._a };
      },
      toRgbString: function () {
        return this._a == 1
          ? "rgb(" + i(this._r) + ", " + i(this._g) + ", " + i(this._b) + ")"
          : "rgba(" +
              i(this._r) +
              ", " +
              i(this._g) +
              ", " +
              i(this._b) +
              ", " +
              this._roundA +
              ")";
      },
      toPercentageRgb: function () {
        return {
          r: i(P(this._r, 255) * 100) + "%",
          g: i(P(this._g, 255) * 100) + "%",
          b: i(P(this._b, 255) * 100) + "%",
          a: this._a,
        };
      },
      toPercentageRgbString: function () {
        return this._a == 1
          ? "rgb(" +
              i(P(this._r, 255) * 100) +
              "%, " +
              i(P(this._g, 255) * 100) +
              "%, " +
              i(P(this._b, 255) * 100) +
              "%)"
          : "rgba(" +
              i(P(this._r, 255) * 100) +
              "%, " +
              i(P(this._g, 255) * 100) +
              "%, " +
              i(P(this._b, 255) * 100) +
              "%, " +
              this._roundA +
              ")";
      },
      toName: function () {
        if (this._a === 0) {
          return "transparent";
        }
        if (this._a < 1) {
          return false;
        }
        return M[v(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function (e) {
        var t = "#" + m(this._r, this._g, this._b, this._a);
        var n = t;
        var r = this._gradientType ? "GradientType = 1, " : "";
        if (e) {
          var i = a(e);
          n = i.toHex8String();
        }
        return (
          "progid:DXImageTransform.Microsoft.gradient(" +
          r +
          "startColorstr=" +
          t +
          ",endColorstr=" +
          n +
          ")"
        );
      },
      toString: function (e) {
        var t = !!e;
        e = e || this._format;
        var n = false;
        var r = this._a < 1 && this._a >= 0;
        var i =
          !t &&
          r &&
          (e === "hex" || e === "hex6" || e === "hex3" || e === "name");
        if (i) {
          if (e === "name" && this._a === 0) {
            return this.toName();
          }
          return this.toRgbString();
        }
        if (e === "rgb") {
          n = this.toRgbString();
        }
        if (e === "prgb") {
          n = this.toPercentageRgbString();
        }
        if (e === "hex" || e === "hex6") {
          n = this.toHexString();
        }
        if (e === "hex3") {
          n = this.toHexString(true);
        }
        if (e === "hex8") {
          n = this.toHex8String();
        }
        if (e === "name") {
          n = this.toName();
        }
        if (e === "hsl") {
          n = this.toHslString();
        }
        if (e === "hsv") {
          n = this.toHsvString();
        }
        return n || this.toHexString();
      },
      _applyModification: function (e, t) {
        var n = e.apply(null, [this].concat([].slice.call(t)));
        this._r = n._r;
        this._g = n._g;
        this._b = n._b;
        this.setAlpha(n._a);
        return this;
      },
      lighten: function () {
        return this._applyModification(w, arguments);
      },
      brighten: function () {
        return this._applyModification(E, arguments);
      },
      darken: function () {
        return this._applyModification(S, arguments);
      },
      desaturate: function () {
        return this._applyModification(g, arguments);
      },
      saturate: function () {
        return this._applyModification(y, arguments);
      },
      greyscale: function () {
        return this._applyModification(b, arguments);
      },
      spin: function () {
        return this._applyModification(x, arguments);
      },
      _applyCombination: function (e, t) {
        return e.apply(null, [this].concat([].slice.call(t)));
      },
      analogous: function () {
        return this._applyCombination(L, arguments);
      },
      complement: function () {
        return this._applyCombination(T, arguments);
      },
      monochromatic: function () {
        return this._applyCombination(A, arguments);
      },
      splitcomplement: function () {
        return this._applyCombination(k, arguments);
      },
      triad: function () {
        return this._applyCombination(N, arguments);
      },
      tetrad: function () {
        return this._applyCombination(C, arguments);
      },
    };
    a.fromRatio = function (e, t) {
      if (typeof e == "object") {
        var n = {};
        for (var r in e) {
          if (e.hasOwnProperty(r)) {
            if (r === "a") {
              n[r] = e[r];
            } else {
              n[r] = q(e[r]);
            }
          }
        }
        e = n;
      }
      return a(e, t);
    };
    a.equals = function (e, t) {
      if (!e || !t) {
        return false;
      }
      return a(e).toRgbString() == a(t).toRgbString();
    };
    a.random = function () {
      return a.fromRatio({ r: u(), g: u(), b: u() });
    };
    a.mix = function (e, t, n) {
      n = n === 0 ? 0 : n || 50;
      var r = a(e).toRgb();
      var i = a(t).toRgb();
      var s = n / 100;
      var o = s * 2 - 1;
      var u = i.a - r.a;
      var f;
      if (o * u == -1) {
        f = o;
      } else {
        f = (o + u) / (1 + o * u);
      }
      f = (f + 1) / 2;
      var l = 1 - f;
      var c = {
        r: i.r * f + r.r * l,
        g: i.g * f + r.g * l,
        b: i.b * f + r.b * l,
        a: i.a * s + r.a * (1 - s),
      };
      return a(c);
    };
    a.readability = function (e, t) {
      var n = a(e);
      var r = a(t);
      var i = n.toRgb();
      var s = r.toRgb();
      var o = n.getBrightness();
      var u = r.getBrightness();
      var f =
        Math.max(i.r, s.r) -
        Math.min(i.r, s.r) +
        Math.max(i.g, s.g) -
        Math.min(i.g, s.g) +
        Math.max(i.b, s.b) -
        Math.min(i.b, s.b);
      return { brightness: Math.abs(o - u), color: f };
    };
    a.isReadable = function (e, t) {
      var n = a.readability(e, t);
      return n.brightness > 125 && n.color > 500;
    };
    a.mostReadable = function (e, t) {
      var n = null;
      var r = 0;
      var i = false;
      for (var s = 0; s < t.length; s++) {
        var o = a.readability(e, t[s]);
        var u = o.brightness > 125 && o.color > 500;
        var f = 3 * (o.brightness / 125) + o.color / 500;
        if ((u && !i) || (u && i && f > r) || (!u && !i && f > r)) {
          i = u;
          r = f;
          n = a(t[s]);
        }
      }
      return n;
    };
    var O = (a.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32",
    });
    var M = (a.hexNames = _(O));
    var z = (function () {
      var e = "[-\\+]?\\d+%?";
      var t = "[-\\+]?\\d*\\.\\d+%?";
      var n = "(?:" + t + ")|(?:" + e + ")";
      var r =
        "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
      var i =
        "[\\s|\\(]+(" +
        n +
        ")[,|\\s]+(" +
        n +
        ")[,|\\s]+(" +
        n +
        ")[,|\\s]+(" +
        n +
        ")\\s*\\)?";
      return {
        rgb: new RegExp("rgb" + r),
        rgba: new RegExp("rgba" + i),
        hsl: new RegExp("hsl" + r),
        hsla: new RegExp("hsla" + i),
        hsv: new RegExp("hsv" + r),
        hsva: new RegExp("hsva" + i),
        hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      };
    })();
    window.tinycolor = a;
  })();
  e(function () {
    if (e.fn.spectrum.load) {
      e.fn.spectrum.processNativeColorInputs();
    }
  });
});
